module.exports = __webpack_public_path__ + "media/luxury-2026/estate-twilight-drone-960-7f8a2da3.jpg";